/**
 * Non-ISO 2-char country codes used in the countries table that Adyen rejects.
 * Maps British Isles / Crown Dependency codes to their ISO 3166-1 alpha-2 equivalent.
 */
const NON_ISO_COUNTRY_MAP: Record<string, string> = {
  XE: 'GB', // England
  XS: 'GB', // Scotland
  XW: 'GB', // Wales
  XI: 'GB', // Northern Ireland
  XN: 'GB', // England (alt)
  XC: 'GB', // Channel Islands
};

/** Map a 2-char country code to its ISO equivalent (e.g. XE → GB). */
export function toIsoCountryCode(code: string | null | undefined): string | undefined {
  if (!code) return undefined;
  const upper = code.trim().toUpperCase();
  return NON_ISO_COUNTRY_MAP[upper] ?? upper;
}
